<div class="notify-box" id="box">
    <div class="header-modal">
        <bc-icon  name="notification" class="iconNotification" style="padding: 3px;" height="30px" aria-hidden="true" aria-label="prueba"></bc-icon>
        <h2 id="h2-title-principal">Notificaciones</h2>
    </div>
    <div class="child">
        <app-item-notification></app-item-notification>
    </div>
</div>